import { render, staticRenderFns } from "./ferramentas.vue?vue&type=template&id=712dbf1b&scoped=true&"
import script from "./ferramentas.vue?vue&type=script&lang=js&"
export * from "./ferramentas.vue?vue&type=script&lang=js&"
import style0 from "./ferramentas.vue?vue&type=style&index=0&id=712dbf1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712dbf1b",
  null
  
)

export default component.exports